<template>
  <wtFormRight>
    <!-- -TOOLBARS -->
    <template slot="toolbars">
      <Toolbars
        :objProps="objItem"
        :objPropsData="objItemData"
        :urlServices="urlServices"
        :primary_key="primary_key"
        :nameObjData="nameObjData"
        :requiredEndDt="requiredEndDt"
        :noDelete="noDelete"
      />
    </template>

    <!-- VIEW TABLE -->
    <template slot="table" v-if="showGrid">
      <ServiceDocGrid @selectedServiceDoc="objRowSelected = $event"></ServiceDocGrid>
    </template>

    <!-- VIEW FORM -->
    <template slot="form" v-if="!showGrid">
      <b-form class="text-uppercase">
        <div class="wt-doc-layout-container">
          <div class="form-row">
            <!--doc-layout-left-start-->
            <div class="wt-doc-layout-left col-md-6">
              <div class="form-group">
                <label for="service_doc_description">Description</label>
                <input
                  type="text"
                  class="form-control"
                  id="service_doc_description"
                  v-model.trim="objItemData.description"
                  @keyup="toUpperCase"
                  placeholder="CREDENTIAL DOC"
                />
              </div>
              <div class="form-group">
                <label for="service_doc_business_owner">Business Owner</label>
                <input
                  type="text"
                  class="form-control"
                  id="service_doc_business_owner"
                  v-model.trim="objItemData.business_owner"
                  placeholder="OWNER NAME"
                />
              </div>
              <div class="form-group">
                <label for="service_doc_version">Version</label>
                <input
                  type="text"
                  class="form-control"
                  id="service_doc_version"
                  v-model.trim="objItemData.version"
                  placeholder="Version 1"
                />
              </div>
            </div>
            <!--doc-layout-left-end-->
            <!--doc-layout-right-start-->
            <div class="wt-doc-layout-right col-md-6">
              <div class="form-group">
                <label for="service_doc_image_url">Image URL</label>
                <input
                  type="text"
                  class="form-control"
                  id="service_doc_image_url"
                  v-model.trim="service_doc_image_url"
                  placeholder="http://"
                />
              </div>
              <img
                id="imgPrev"
                class="wt-image-preview"
                alt="Image Preview"
                :src="service_doc_image_url"
                @error="imgPreviewDefault"
              />
            </div>
            <!--doc-layout-right-end-->
          </div>
        </div>

        <!-- Line 01 -->
        <div class="form-row">
          <div class="form-group col-md-12">
            <div class="wt-label-with-logo">
              <img class="swagger-logo" src="@/assets/default/swagger.png" alt="swagger logo" />
              <label for="service_doc_service_url">Service URL (Swagger)</label>
            </div>
            <input
              type="text"
              class="form-control"
              id="service_doc_service_url"
              v-model.trim="objItemData.service_url"
              placeholder="http://"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="service_doc_pre_production_address_service">Pre Production Address Service</label>
            <input
              type="text"
              class="form-control"
              id="service_doc_pre_production_address_service"
              v-model.trim="objItemData.pre_production_address_service"
              placeholder="http://"
            />
          </div>
          <div class="form-group col-md-6">
            <label for="service_doc_production_address_service">Production Address Service</label>
            <input
              type="text"
              class="form-control"
              id="service_doc_production_address_service"
              v-model.trim="objItemData.production_address_service"
              placeholder="http://"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="service_doc_keyword_tag_input">Keywords</label>
            <div class="wt-tag-row">
              <p
                class="wt-tag"
                v-for="(service_doc_keyword_tag, index) in service_doc_keyword_tags"
                :key="index"
              >
                {{service_doc_keyword_tag}}
                <span
                  class="wt-tag-delete"
                  @click="service_doc_keyword_tags.splice(index, 1)"
                >&times;</span>
              </p>

              <span class="wt-tag-hide" id="service_doc_keyword_hide"></span>
              <input
                class="wt-tag-input"
                id="service_doc_keyword_tag_input"
                type="text"
                maxlength="50"
                :placeholder="placeholder"
                v-model.trim="service_doc_keyword_tag"
                @keypress.prevent.stop="ServiceDocKeywordAddTag"
              />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="service_doc_url_doc_reference_tag_input">URL Doc References</label>
            <div class="wt-tag-column">
              <span class="wt-tag-hide" id="service_doc_url_doc_reference_hide"></span>
              <input
                class="wt-tag-input"
                id="service_doc_url_doc_reference_tag_input"
                type="text"
                :placeholder="placeholder"
                v-model.trim="service_doc_url_doc_reference_tag"
                @keypress.prevent.stop="ServiceDocUrlDocReferenceAddTag"
              />
              <p
                class="wt-tag"
                v-for="(service_doc_url_doc_reference_tag, index) in service_doc_url_doc_reference_tags"
                :key="index"
              >
                <span
                  class="wt-tag-delete"
                  @click="service_doc_url_doc_reference_tags.splice(index, 1)"
                >&times;</span>
                {{service_doc_url_doc_reference_tag}}
              </p>
            </div>
          </div>
        </div>
      </b-form>
    </template>
  </wtFormRight>
</template>
<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/* COMPONENTS - LAYOUT */
import wtFormRight from "@/components/forms/wtFormRight";
import Toolbars from "@/components/widgets/Toolbars";

/* COMPONENTS - PAGE */
import ServiceDocGrid from "./ServiceDocGrid";

export default {
  name: "ServiceDoc",

  /* COMPONENTS IN USE */
  components: { wtFormRight, Toolbars, ServiceDocGrid },

  /* COMPUTED VARIABLES */
  computed: {
    showGrid() {
      return this.$store.state.layout.showGrid;
    },
    urlServicesStore() {
      return this.$store.state.urlServicesStore;
    },
    objShared() {
      return this.$store.state.objShared;
    },
    objSelected() {
      return this.$store.state.objSelected;
    },
    action() {
      return this.$store.state.action;
    }
  },

  /* VARIABLES */
  data: function() {
    return {
      /* Controls */
      urlServices: "streamline-ds/api/internal/service-doc",
      primary_key: "service_doc_id",

      /* Objects Page */
      objItem: {},
      objItemData: {},
      objRowSelected: {},
      nameObjData: "service_doc_data",
      requiredEndDt: false,
      noDelete: false,

      /* Tags Entry */
      service_doc_keyword_tag: "",
      service_doc_keyword_tags: [],
      service_doc_url_doc_reference_tag: "",
      service_doc_url_doc_reference_tags: [],
      placeholder: 'Add tag with "Enter"',

      /* Image Preview */
      service_doc_image_url: ""

      /* Others Query */
    };
  },

  /* METHODS */
  /** @namespace */
  methods: {
    /* pay attention, this method has been changed */
    load(objItem) {
      this.$store.commit("setShowLoading", true);
      this.$store.commit("setShowGrid", false);

      const param = {};
      param[`${this.primary_key}`] = objItem[`${this.primary_key}`];
      const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find/`;

      axios.post(url, param).then(res => {
        this.objItem = res.data[0];
        this.objItemData = this.objItem[`${this.nameObjData}`];
        this.$store.commit("setShowLoading", false);
        /* new */
        this.service_doc_keyword_tags = this.stringToArray(
          this.objItemData.keywords
        );
        this.service_doc_url_doc_reference_tags = this.stringToArray(
          this.objItemData.url_doc_references
        );
        this.service_doc_image_url = this.objItemData.image_url;
      });
    },

    /* Exclusives */
    stringToArray(input) {
      var adapt = String(input).replace("[", "");
      adapt = adapt.replace("]", "");
      adapt = adapt.replace(/'/g, "");
      adapt = adapt.replace(/"/g, "");
      adapt = adapt.split(",");
      return adapt;
    },

    setExclusiveLocalData() {
      this.service_doc_keyword_tags = this.stringToArray(
        this.objItemData.keywords
      );
      this.service_doc_url_doc_reference_tags = this.stringToArray(
        this.objItemData.url_doc_references
      );
      this.service_doc_image_url = this.objItemData.image_url;
    },

    /* Image Preview */
    imgPreviewDefault(event) {
      event.target.src = require("@/assets/default/preview_img.png");
    },

    /* Tags */
    clearTags(input, type) {
      var adapt = "";
      if (type == "text")
        adapt = String(input).replace(/["]|[']|\[|\]|{|}|,|;|\.| /g, "");
      if (type == "link") adapt = String(input).replace(/[']|\[|\]|{|}| /g, "");
      return adapt;
    },

    /**
     * Recebe a informação de entrada de key para tratamento da tag
     * realiza a limpeza da string e confirma a adição de a key utilizada
     * fizer parte da list. Salva em 'service_doc_keyword_tags'
     * @param {event} evento
     */
    ServiceDocKeywordAddTag(event) {
      if ([",", ".", ";", "Enter", " "].includes(event.key)) {
        if (
          this.service_doc_keyword_tag &&
          !this.service_doc_keyword_tags.includes(this.service_doc_keyword_tag)
        ) {
          this.service_doc_keyword_tags.push(
            this.service_doc_keyword_tag.toLowerCase()
          );
          this.service_doc_keyword_tag = "";
        }
      } else {
        this.service_doc_keyword_tag += event.key;
        this.service_doc_keyword_tag = this.clearTags(
          this.service_doc_keyword_tag,
          "text"
        );
      }
    },

    ServiceDocUrlDocReferenceAddTag(event) {
      if (["Enter", " "].includes(event.key)) {
        if (
          this.service_doc_url_doc_reference_tag &&
          !this.service_doc_url_doc_reference_tags.includes(
            this.service_doc_url_doc_reference_tag
          )
        ) {
          this.service_doc_url_doc_reference_tags.push(
            this.service_doc_url_doc_reference_tag.toLowerCase()
          );
          this.service_doc_url_doc_reference_tag = "";
        }
      } else {
        this.service_doc_url_doc_reference_tag += event.key;
        this.service_doc_url_doc_reference_tag = this.clearTags(
          this.service_doc_url_doc_reference_tag,
          "link"
        );
      }
    },
    toUpperCase() {
      this.objItemData.description = this.objItemData.description.toUpperCase();
    }
  },

  /* WATCH */
  watch: {
    objRowSelected() {
      this.load(this.objRowSelected);
      this.$store.commit("setAction", "modify");
    },
    objSelected() {
      if (this.urlServicesStore === this.urlServices) {
        if (Object.entries(this.objSelected).length === 0) {
          this.$emit("ServiceDocSelected", null);
        } else {
          this.$emit("ServiceDocSelected", this.objSelected.access_key);
        }
      }
    },
    /* pay attention, this watcher has been changed */
    action() {
      if (this.urlServicesStore === this.urlServices) {
        if (this.action === "reset") {
          this.objItem = {};
          this.objItemData = {};
          /* new */
          this.service_doc_keyword_tags = [];
          this.service_doc_url_doc_reference_tags = [];
          this.service_doc_image_url = "";
        }
      }
    },

    /* Exclusives */
    /* INPUT AUTO-SIZING TAGS */
    service_doc_keyword_tag() {
      var hideText = document.getElementById("service_doc_keyword_hide");
      var tagInput = document.getElementById("service_doc_keyword_tag_input");
      if (this.service_doc_keyword_tag) {
        hideText.textContent = tagInput.value + "A";
      } else {
        hideText.textContent = this.placeholder;
      }
      tagInput.style.width = hideText.offsetWidth + 10 + "px";
    },

    /* ARRAY TO OBJITEMDATA */
    service_doc_keyword_tags() {
      this.objItemData.keywords = [];
      this.service_doc_keyword_tags.forEach(element => {
        this.objItemData.keywords.push(element);
      });
    },

    service_doc_url_doc_reference_tags() {
      this.objItemData.url_doc_references = [];
      this.service_doc_url_doc_reference_tags.forEach(element => {
        this.objItemData.url_doc_references.push(element);
      });
    },

    /* PREVIEW DA IMAGEM */
    service_doc_image_url() {
      this.objItemData.image_url = this.service_doc_image_url;
    }
  }
};
</script>